import type { HealthStatus, SyncState } from "../api/types";
import { SYNC_STATUS_LABELS } from "../utils/format";

type Tone = "success" | "warning" | "danger" | "neutral" | "info";

export function StatusBadge({ tone = "neutral", children }: { tone?: Tone; children: React.ReactNode }) {
  return <span className={`status-badge status-badge--${tone}`}>{children}</span>;
}

export function ApiStatusBadge({ health, loading }: { health?: HealthStatus; loading: boolean }) {
  const connected = health?.status === "ok";
  const tone: Tone = loading ? "neutral" : connected ? "success" : health?.status === "degraded" ? "warning" : "danger";
  const label = loading ? "서버 확인 중" : connected ? "서버 연결됨" : health?.status === "degraded" ? "서버 점검 필요" : "서버 연결 안 됨";
  return (
    <StatusBadge tone={tone}>
      <i className="status-dot" aria-hidden="true" />
      {label}
    </StatusBadge>
  );
}

export function SyncStatusBadge({ state, pendingCount }: { state?: SyncState; pendingCount?: number }) {
  if (!state) return <StatusBadge>동기화 확인 중</StatusBadge>;
  const tone: Tone = state === "SYNCED" ? "success" : state === "ERROR" ? "danger" : state === "DISABLED" ? "neutral" : "warning";
  const suffix = pendingCount ? ` ${pendingCount}건` : "";
  return (
    <StatusBadge tone={tone}>
      <i className="status-dot" aria-hidden="true" />
      {SYNC_STATUS_LABELS[state]}{suffix}
    </StatusBadge>
  );
}
